<div class="page-content bg-white">
  <!-- inner page banner -->
  <!-- <div class="dez-bnr-inr overlay-black-middle" style="background-image:url('/assets/images/bg4.jpg');">
    <div class="container">
      <div class="dez-bnr-inr-entry">
        <h1 class="text-white">MANUALES COVID – 19 - MPD</h1>
      </div>
    </div>
  </div> -->
  <!-- inner page banner END -->
  <!-- Breadcrumb row -->
  <div class="breadcrumb-row">
    <div class="container">
      <ul class="list-inline">
        <li><a href="#">Inicio</a></li>
        <li>Manuales covid - 19 - MPD</li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumb row END -->
  <!-- contact area -->
  <div class="content-area">
    <!-- Career -->
    <div class="container">
      <div class="row">
        <!-- Left part start -->
        <div class="col-md-9 m-b30">
          <h1 class="m-b20 m-t0">MANUALES DE CONTENCIÓN, PREVENCIÓN Y BIOSEGURIDAD DEL COVID – 19</h1>
          <div class="dez-separator bg-primary"></div>
          <div>
            <div
              style="background-color: darkgrey;border-radius: 10px;padding: 20px;display: inline flow-root list-item">
              <a href="/assets/manual-covid/MANUAL_DE_BIOSEGURIDAD.pdf" target="_blank">
                <img src="/assets/manual-covid/1.png" style="height: 400px;" alt="">
              </a>

            </div>
            <div
              style="background-color: darkgrey;border-radius: 10px;padding: 20px;display: inline flow-root list-item">
              <a href="/assets/manual-covid/PRESENTACION_MANUAL_PREV_CONT_COVID_MPD.pdf" target="_blank">
                <img src="/assets/manual-covid/2.png" style="height: 400px;" alt="">
              </a>
            </div>
          </div>



        </div>
        <!-- Left part start END -->
        <!-- Right part start -->

        <!-- Right part start END -->
      </div>
    </div>
    <!-- Career END -->
  </div>
  <!-- contact area END -->
</div>


// WEBPACK FOOTER //
// ./src/app/pages/covid/covid.component.html